import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Fade } from "react-awesome-reveal";
import { LinkContext } from "../../LinkProvider";

import ctaCard from "../../img/home/cta-card.webp";
import bannerCloud from "../../img/home/banner-cloud.webp";

function CTASection() {
  const { t } = useTranslation();
  const { link } = useContext(LinkContext);

  return (
    <section className="mt mb-[80px] lg:mb-[200px]">
      <div className="glcontainer">
        <Fade triggerOnce direction="up" duration={700}>
        <div className="relative lg:pt-[30px]">
          <div className="relative bg-[#30425a] rounded-[20px] lg:rounded-[40px] overflow-hidden px-[20px] py-[30px] lg:px-[70px] lg:py-[65px]">
            {/* Текст слева */}
            <div className="relative z-10 max-w-[434px] mx-auto lg:mx-0 flex flex-col gap-[35px] text-center lg:text-left">
              <div className="flex flex-col gap-[15px]">
                <div className="flex flex-col gap-[4px]">
                  <h2 className="font-42-28 !text-white">{t("cta.title1")}</h2>
                  <h3 className="font-32-22 !text-white">{t("cta.title2")}</h3>
                </div>
                <p className="font-16-14 !text-white">{t("cta.subtitle")}</p>
              </div>

              <a
                href={link}
                className="inline-flex w-fit mx-auto lg:mx-0 items-center justify-center px-[28px] lg:px-[42px] py-[12px] lg:py-[18px] rounded-[40px] border border-white font-['Inter'] font-bold text-[14px] lg:text-[16px] text-white capitalize backdrop-blur-[15px] hover:opacity-90 transition-opacity"
                style={{
                  backgroundImage:
                    "linear-gradient(-84deg, rgba(255,255,255,0.4) 6%, rgba(204,222,255,0.4) 66%)",
                }}
              >
                {t("cta.btn")}
              </a>
            </div>

            {/* Mobile: картинка под кнопкой — крупнее и прижата к низу карточки */}
            <div className="lg:hidden mt-[25px] -mb-[30px] flex justify-center">
              <img
                src={ctaCard}
                alt=""
                aria-hidden
                className="w-[78%] max-w-[340px] aspect-square object-cover object-top"
              />
            </div>
          </div>

          {/* Desktop: картинка выступает над карточкой */}
          <div className="hidden lg:block absolute left-[46%] top-0 bottom-0 w-[43.4%] pointer-events-none">
            <img
              src={ctaCard}
              alt=""
              aria-hidden
              className="w-full h-full object-cover object-[50%_28%]"
            />
          </div>

          {/* Облака поверх картинки, как в макете */}
          <img
            src={bannerCloud}
            alt=""
            aria-hidden
            className="hidden lg:block absolute left-[66.5%] top-[72px] w-[52.9%] opacity-50 -scale-x-100 pointer-events-none select-none"
          />
          <img
            src={bannerCloud}
            alt=""
            aria-hidden
            className="hidden lg:block absolute left-[38.4%] top-[-5px] w-[34.1%] opacity-50 pointer-events-none select-none"
          />
        </div>
        </Fade>
      </div>
    </section>
  );
}

export default CTASection;
